module.exports = __webpack_public_path__ + "media/fonts/OFN-v2-bf26ca825fba42e2c8939d6a86df6f92.svg";